// In jQuery, any $(document).ready callback that throws an error blocks others.
// Instead, capture these exceptions, log them to the console, and keep running.

function jquerySafeReady($) {
  $.fn.ready = (proceed =>
    // our new $(document).ready, taking the presumed-buggy callback "unsafe":
    function(unsafe) {
      // runs that callback inside a try-catch that also logs errors helpfully
      function safely() {
        try {
          unsafe.apply(this, arguments);
        } catch (e) {
          const msg = 'Exception in a jQuery.ready callback: ';
          if (window.console && typeof window.console.error === 'function') {
            window.console.error(msg, e);
          } else {
            const err = new Error(msg + e.message);
            err.original = e;
            setTimeout(() => {
              throw err;
            }, 0);
          }
        }
      }

      // hands over our safer callback to jQuery's "native" $.fn.ready handler

      return proceed(safely);
    })($.fn.ready);

  return $.fn.ready;
}

module.exports = jquerySafeReady;
